// extracted by mini-css-extract-plugin
export default {"loginSignupHeader":"login_loginSignupHeader__qW0fF","loginForm":"login_loginForm__v+mLk","field":"login_field__j4R7X"};